import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  personaSidebarOpen: {
    component: '',
    name: 'Stable Status Quo',
    value: 0,
    open: false
  },
  personas: [],
  selectedPersonas: [],
  personasToggle: false
}

const personaSlice = createSlice({
  name: 'persona',
  initialState,
  reducers: {
    setPersonaSidebarOpen: (state, action) => {
      state.personaSidebarOpen = action.payload
    },
    setPersonas: (state, action) => {
      state.personas = action.payload
    },
    setSelectedPersonas: (state, action) => {
      state.selectedPersonas = action.payload
    },
    setPersonasToggle: (state, action) => {
      state.personasToggle = action.payload
    }
  }
})

export const {setPersonaSidebarOpen, setPersonas, setSelectedPersonas, setPersonasToggle} = personaSlice.actions

// Selectors with null-safe defaults
export const selectPersonaSidebarOpen = (state) =>
  state.persona?.personaSidebarOpen ?? {
    component: '',
    name: 'Stable Status Quo',
    value: 0,
    open: false
  }
export const selectPersonas = (state) => state.persona?.personas ?? []
export const selectSelectedPersonas = (state) => state.persona?.selectedPersonas ?? []
export const selectPersonasToggle = (state) => state.persona?.personasToggle ?? false

export default personaSlice.reducer
